/**
 * Copyright © Veeam Software Group GmbH.
 */

import { useContext } from 'react';

import { LicenseStatusContext } from '../contexts';

export const useLicenseStatusStore = () => useContext(LicenseStatusContext);
